import Vue from 'vue'

const set = prop => (state, val) => {
  state[prop] = val
}

export const layersTree = set('layersTree')
export const layersSorted = set('layersSorted')
export const layerTreeUpdate = set('layersTree')
export const temporalLayers = set('temporalLayers')
export const layersLoaded = set('layersLoaded')
export const permaLayers = set('permaLayers')
export const permaLabels = set('permaLabels')
export const permaProfile = set('permaProfile')
export const currentInfoItem = set('currentInfoItem')
export const infoToolLine = set('infoToolLine')
export const setInfoLayerTree = set('infoLayerTree')
export const constraintPhotosId = set('constraintPhotosId')
export const filterInfoKey = set('filterInfoKey')
export const designotron = set('designotron')
export const logitron = set('logitron')
export const currentEditor = set('currentEditor')
export const commentState = set('commentState')
export const initialised = set('initialised')
export const currentCommentIssue = set('currentCommentIssue')
export const commentIssues = set('commentIssues')
export const linkShow = set('linkShow')
export const searchShow = set('searchShow')
export const profileShow = set('profileShow')
export const temporalShow = set('temporalShow')
export const mapSize = set('mapSize')
export const printMode = set('printMode')
export const printProfile = set('printProfile')
export const potreeLoaded = set('potreeLoaded')
export const loadingTiles = set('loadingTiles')
export const qeuedLayers = set('qeuedLayers')
export const scopeAOI = set('scopeAOI')
export const scopeState = set('scopeState')

export const hideAllWidgets = set('hideAllWidgets')
export const context_coords = set('context_coords')
export const context_centreline = set('context_centreline')
export const context_elevation = set('context_elevation')
export const flow_uls_tables = set('flow_uls_tables')
export const flow_mode = set('flow_mode')
export const angle3d = set('angle3d')
export const loadingFlowInteraction = set('loadingFlowInteraction')
export const camera3dPotistion = set('camera3dPotistion')

export const showReleaseNotes = set('showReleaseNotes')
export const showTour = set('showTour')

export const phaseOptions = set('phaseOptions')
export const profileMode = set('profileMode')

export const reduceLoadingTiles = (state, val) => {
  state.loadingTiles = state.loadingTiles - val
}

export const view3dtiles = (state, val) => {
  state.view3dtiles.splice(0, state.view3dtiles.length)
  val.forEach(v => {
    state.view3dtiles.push(v)
  })
}

export const infoLayerTree = (state, rootNode) => {
  let index = state.infoLayerTree.map(n => n.name).indexOf(rootNode.name)
  if (index > -1) {
    state.infoLayerTree.splice(index, 1, rootNode)
  } else {
    state.infoLayerTree.push(rootNode)
  }
}
export const center = (state, val) => {
  let s = state.mapScope[val[0]] ? {...state.mapScope[val[0]]} : {}
  s['center'] = val[1]
  state.mapScope[val[0]] = s
  state.currentMapCenter = s['center']
}

export const resolution = (state, val) => {
  let s = state.mapScope[val[0]] ? {...state.mapScope[val[0]]} : {}
  s['resolution'] = val[1]
  state.mapScope[val[0]] = s
}

export const toggleLegend = (state, val) => {
  let index = state.activatedLegends.map(l => l.id).indexOf(val.id)
  if (index > -1) {
    state.activatedLegends.splice(index, 1)
  } else {
    state.activatedLegends.push(val)
  }

}

export const addTemporalLayer = (state, val) => {
  let index = state.temporalLayers.map(l => l.id).indexOf(val.id)
  if (index === -1) {
    state.temporalLayers.push(val)
  }

}

export const setLayerLabel = (state, val) => {
  Vue.set(state.renderedLabelsMap, val[0], val[1])
}

export const setLayerFilter = (state, val) => {
  Vue.set(state.layerFiltersMap, val[0], val[1])
}

export const widgetResizeMap = (state, val) => {
  Vue.set(state.widgetResizeMap, val[0], val[1])
}

export const removeTemporalLayer = (state, layer) => {
  let index = state.temporalLayers.map(l => l.id).indexOf(layer['id'])
  if (index > -1) {
    state.temporalLayers.splice(index, 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/map/mutations.js